import { createSlice } from '@reduxjs/toolkit'

import { AlertData, AlertVariant } from 'types'

export const alertUI = createSlice({
  name: 'alertUI',
  initialState: {
    messages: [] as AlertData[],
    type: 'error' as AlertVariant,
    time: 6000,
  },
  reducers: {
    setAlertType: (state, { payload }) => {
      state.type = payload
    },
    setAlertTime: (state, { payload }) => {
      state.time = payload
    },
    setAlertMessages: (state, { payload }) => {
      state.messages = payload
    },
  },
})

export const { setAlertType, setAlertTime, setAlertMessages } = alertUI.actions

export default alertUI.reducer
